import { useQuery } from "@tanstack/react-query";

import { getThemes } from "../../api/Theme";
import { ITheme, IThemePage } from "shared";

export const useThemes = () => {
  return useQuery<ITheme<IThemePage>[]>(["themes"], () => getThemes());
};
